import invoice from '@/api/invoice-for-no-enroll'


import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  formViewModel(context, attributes = {}){
    return invoice.formViewModel({ 
      params: attributes
    })
  },
  store(context, data) {
    return invoice.store(data)
  }
}
